import React, { useState, useCallback } from 'react';
import WhatsAppLogo from '../../assets/WhatsApp.svg';
import './ResultCardAlert.css';

function ResultCardAlert({ packageHoliday, onClose }) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isValidPhoneNumber = (number) => {
    // Remove all spaces and special characters
    const cleaned = number.replace(/\s+/g, '').replace(/[-()+]/g, '');
    
    // Check if it starts with 0 or +44 or 44 and has 10-11 digits after that
    const ukRegex = /^(?:0|44|\+44)?([1-9]\d{9,10})$/;
    return ukRegex.test(cleaned);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    if (!isValidPhoneNumber(phoneNumber)) {
      setError('Please enter a valid UK phone number');
      setIsSubmitting(false);
      return;
    }
    
    const formattedNumber = phoneNumber
      .replace(/\s+/g, '')
      .replace(/^0/, '44')
      .replace(/^\+44/, '44');
    
    try {
      const response = await fetch('https://conversation.claiva.com/intents', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user: {
            platform: "twiliowhatsapp",
            channel: "MG5bd18492eb1a640bcab5a848a3437222",
            channel_id: formattedNumber
          },
          intentName: "alertSignupAgent",
          intent: {
            itemKey: packageHoliday.ItemKey,
            occupancy: {
              adults: 2,
              children: 0,
              infants: 0
            },
            brand: packageHoliday.Brand || "OTB"
          }
        })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      setIsSubmitted(true);
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error submitting alert:', error);
      setError('Something went wrong. Please try again.');
      setIsSubmitting(false);
    }
  };

  const handleOverlayClick = useCallback((e) => {
    if (e.target.className === 'alert-overlay') {
      onClose();
    }
  }, [onClose]);

  return (
    <div className="alert-overlay" onClick={handleOverlayClick}>
      <div className="alert-modal">
        <button className="close-button" onClick={onClose}>×</button>
        
        <div className="alert-content">
          <h2 className="alert-title">Watch this</h2>
          
          <div className="alert-features">
            <div className="alert-feature">
              <span className="material-icons-outlined alert-icon">notifications_none</span>
              <span>Send me price drops for this and similar deals</span>
            </div>
            <div className="alert-feature">
              <span className="material-icons-outlined alert-icon">security</span>
              <span>No spam, just useful updates</span>
            </div>
          </div>
          
          <div className="phone-section">
            <label className="phone-label">Your phone number</label>
            <input
              type="tel"
              placeholder="Enter your UK mobile number"
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value);
                setError('');
              }}
              className={`phone-input ${error ? 'error' : ''}`}
              disabled={isSubmitted}
            />
            {error && <div className="error-message">{error}</div>}
          </div>
          
          <button 
            onClick={handleSubmit}
            className="track-button"
            disabled={isSubmitting || isSubmitted}
          >
            <img src={WhatsAppLogo} alt="WhatsApp" className="whatsapp-logo-small" />
            {isSubmitting ? 'Submitting...' : isSubmitted ? 'Submitted' : 'Track with WhatsApp'}
          </button>
          
          {isSubmitted ? (
            <p className="success-message">
              Keep an eye on your WhatsApp for updates and notifications about this holiday
            </p>
          ) : (
            <p className="terms-text">
              By continuing, you agree to receive alerts via WhatsApp. You can stop them at any time.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResultCardAlert; 